import { IconTextButton } from './IconTextButton';
import { ButtonColors } from './NineSliceButton';

export class AdButton extends IconTextButton {
    constructor(width: number, height: number, btnText: string) {
        const iconId = 'commonui/button-icon-ad';
        super({ width, height, btnText, iconId, color: ButtonColors.BLUE });
    }
}
